var lastScrollTop = 0;
if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}


function forceAutoplay() {
	const activeVideo = document.querySelector('.swiper-slide video.hero-video');
	
	if (activeVideo) {
		activeVideo.pause();         
		activeVideo.currentTime = 0; 
		activeVideo.muted = true;     

		const playPromise = activeVideo.play();
		if (playPromise !== undefined) {
			playPromise.catch((error) => {
				console.warn('Autoplay no se pudo iniciar:', error);
			});
		}
	}
}

let visit_content = document.querySelector('.visit-content');

//🔹 Seasons
let season_one = document.getElementById("season-one");
let season_two = document.getElementById("season-two");
let season_three = document.getElementById("season-three");
let season_four = document.getElementById("season-four");

season_one = season_one ? season_one.innerHTML.trim() : null;
season_two = season_two ? season_two.innerHTML.trim() : null;
season_three = season_three ? season_three.innerHTML.trim() : null;
season_four = season_four ? season_four.innerHTML.trim() : null;

if (season_three === "none") season_three = null;
if (season_four === "none") season_four = null;

let seasons = [season_one, season_two, season_three, season_four].filter(Boolean);
let totalSeasons = seasons.length;
var savedSeason = localStorage.getItem("selectedSeason") || "summer";
let toggleIconsState = JSON.parse(localStorage.getItem("toggleIcons")) || [true, false];

function changeSeason(season) {
    savedSeason = season;
    localStorage.setItem("selectedSeason", season);
    let body = document.querySelector("body");
    seasons.forEach(s => body.classList.remove(s + "-theme"));
    body.classList.add(season + "-theme");
    document.querySelectorAll(".season-option").forEach(el => {
        el.classList.toggle("true", el.innerHTML.trim() === season);
    });
}

(function () {

	let checkbox_required = document.querySelector("#form_id-4450-yes-signup-formemail-signup, #form_id-4324-yes-signup-formemail-signup, #form_id-4442-yes-signup-formemail-signup, #form_id-4449-yes-signup-formemail-signup, #form_id-4434-yes-signup-formemail-signup,#form_id-4410-yes-signup-formemail-signup");
	if( checkbox_required ){
		checkbox_required.classList.add( "required" )
	}

    function updateSeason(season) {
        localStorage.setItem("selectedSeason", season);
        updateHeroImages(season);
        updateIntroImages(season);
        updateGallery(season);
        updateGalleryBackground(season);
        updateCustomImages(season);
		updateGallerySliderMobile(season);
		emulateGalleryFilterClick(season);
		forceAutoplay();
	}

	//checking lightbox
	document.querySelectorAll('a').forEach( link => {
		link.addEventListener('click', (e) => {
			let currentTarget = link.getAttribute('href');
			if(currentTarget.indexOf('#') === 0){
				if( document.querySelector(currentTarget) && document.querySelector(currentTarget).classList.contains('lightbox') ){
					e.preventDefault();
					document.querySelector(currentTarget).classList.add('opened');
				}
			}
		});
	});
	if( document.querySelector('.js-lightbox_close')){
		document.querySelectorAll('.js-lightbox_close').forEach( link => {	
			link.addEventListener('click', (e) => {
				e.preventDefault();
				document.querySelector(`#${link.dataset.target}`).classList.remove('opened');
			});
		})
	}
	
	function emulateGalleryFilterClick(season) {
		setTimeout(() => {
			const galleryFilters = document.querySelectorAll('.filter-button');
			const selectFilter = document.getElementById('select_category_gallery');
	
			galleryFilters.forEach(button => {
				let buttonSeason = button.getAttribute('data-filter') || button.getAttribute('data-tag') || button.innerText.trim();
				if (buttonSeason && buttonSeason.toLowerCase() === season.toLowerCase()) {
					button.click();
				}
			});
	
			if (selectFilter) {
				const options = Array.from(selectFilter.options);
				options.forEach(option => {
					if (option.value && option.value.toLowerCase() === season.toLowerCase()) {
						selectFilter.value = option.value;
						const event = new Event('change', { bubbles: true });
						selectFilter.dispatchEvent(event);
					}
				});
			}
		}, 50);
	}
	

    function filterElementsBySeason(elements, season, parentSelector) {
        var parent = document.querySelector(parentSelector);
        if (!parent) return;
        parent.innerHTML = "";
        elements.forEach(el => {
            if (el.dataset.season === season || el.dataset.category === season) {
                parent.appendChild(el);
            }
        });
    }

    function parseDataImages(element) {
        try {
            var images = JSON.parse(element.getAttribute("data-images") || "[]");
            return images.map(({ src, name, category, title }) => ({ src, name, category, title })).filter(img => img.src && img.src.startsWith("http"));
        } catch (error) {
            return [];
        }
    }

    var heroSlides = [...document.querySelectorAll(".top-content__images .swiper-wrapper.seasons .swiper-slide")];
    function updateHeroImages(season) {
        filterElementsBySeason(heroSlides, season, ".top-content__images .swiper-wrapper.seasons");
    }

    var introImages = [...document.querySelectorAll(".intro-content__right.seasons figure")];
    function updateIntroImages(season) {
        filterElementsBySeason(introImages, season, ".intro-content__right.seasons");
    }

	function updateGallery(season) {
		const isMobile = /iPhone|Android/i.test(navigator.userAgent);
	
		document.querySelectorAll(".js-gallery-images").forEach(gallery => {
			const allImages = parseDataImages(gallery);
	
			const isMapMobile = gallery.classList.contains("js-map-mobile");
			const targetSeason = isMapMobile ? 'mobile-' + season : season;

			let filteredImages;

			if (isMapMobile) {
				const mobileOnlyImages = allImages.filter(img => img.category === "mobile");

				if (mobileOnlyImages.length > 0) {
					filteredImages = mobileOnlyImages;
				} else {
					filteredImages = allImages.filter(img => 
						img.category === targetSeason || img.category === "image"
					);
				}
			} else {
				filteredImages = allImages.filter(img => 
					img.category === targetSeason || img.category === "image"
				);
			}
			if (filteredImages.length === 0) return;
	
			gallery.innerHTML = "";
	
			filteredImages.forEach(img => {
				let figure = document.createElement("figure");
	
				if (gallery.classList.contains("js-with-lightbox")) {
					const imageHTML = `<img src="${img.src}.webp" alt="${img.title}">`;
					figure.innerHTML = imageHTML;
	
					const link = document.createElement("a");
					link.href = `${img.src}.webp`;
					if (!isMobile) {
						link.setAttribute("data-lbx", "");
					}
					link.setAttribute("data-lbx-group", "gallery-" + season);
					link.setAttribute("aria-label", "open image " + img.title + " in a lightbox");
	
					const overlay = document.createElement("div");
					overlay.className = "overlay";
	
					link.appendChild(overlay);
					figure.appendChild(link);
				} else {
					figure.innerHTML = `<img src="${img.src}.webp" alt="${img.title}" width="100" height="100">`;
				}
	
				gallery.appendChild(figure);
			});
		});
	}
	
	
	  
	function updateGallerySliderMobile(season) {
		
		document.querySelectorAll(".js-gallery-images-slider").forEach(gallery => {
			var allImages = parseDataImages(gallery);
			// var filteredImages = allImages.filter(img => img.category === season);
			let filteredImages;

			(document.querySelector(".custom-select-wrapper") === null ) ?  (filteredImages = allImages) : filteredImages = allImages.filter(img => img.category === season);
			if (filteredImages.length === 0) return;
	
			gallery.innerHTML = "";
	
			let swiperWrapper = document.createElement("div");
			swiperWrapper.classList.add("swiper-wrapper");
	
			filteredImages.forEach(img => {
				let figure = document.createElement("figure");
				figure.classList.add("swiper-slide"); 
				figure.innerHTML = `<img src="${img.src}.webp" alt="${img.title}" width="100" height="100">`;
				swiperWrapper.appendChild(figure);
			});
	
			if (filteredImages.length > 0) {
				let swiperContainer = document.createElement("div");
				swiperContainer.classList.add("swiper");
	
				let pagination = document.createElement("div");
				pagination.classList.add("swiper-pagination", "pagination-slider");
	
				swiperContainer.appendChild(swiperWrapper);
				swiperContainer.appendChild(pagination);
				gallery.appendChild(swiperContainer);
	
				new Swiper(swiperContainer, {
					loop:false,
					slidesPerView: 1,
					spaceBetween: 10,
					pagination: { 
						el: pagination, 
						clickable: true 
					}
				});
			}
		});
	}
	

	function updateGalleryBackground(season) {
		document.querySelectorAll(".js-gallery-images-background").forEach(bgContainer => {
			var allImages = parseDataImages(bgContainer);
			var filteredBackgrounds = allImages.filter(img => 
				img.category === "background" || img.category === "background-" + season
			);
	
			if (filteredBackgrounds.length === 0) return;
	
			bgContainer.innerHTML = "";
	
			filteredBackgrounds.forEach(img => {
				let figure = document.createElement("figure");
	
				let src_name = img.name || ""; 
				let src = img.src || "";
	
				if (!src_name.endsWith(".svg")) {
					src = src + ".webp";
				} else {
					src = src + ".svg";
				}
	
				figure.innerHTML = `<img src="${src}" alt="${img.title}" width="100" height="100">`;
				bgContainer.appendChild(figure);
			});
		});
	}
	
	

    function updateCustomImages(season) {
        document.querySelectorAll(".js-custom-images").forEach(figure => {
            var images;
            try {
                images = JSON.parse(figure.getAttribute("data-images"));
            } catch (error) {
                return;
            }
            if (!images || !images[season]) return;
            figure.innerHTML = "";
            let imgData = images[season][0];
            if (imgData && imgData.src) {
                let img = document.createElement("img");
                img.src = imgData.src;
                img.alt = imgData.alt;
                figure.appendChild(img);
            }
        });
    }

    updateSeason(savedSeason);

    var toggleSeason = document.getElementById("toggle-season");
    if (toggleSeason && season_one && season_two) {
        toggleSeason.addEventListener("change", function () {
            updateSeason(this.checked ? season_two : season_one);
        });
    }

    document.querySelectorAll(".season-option").forEach(seasonItem => {
        seasonItem.addEventListener("click", function () {
            document.querySelectorAll(".season-option.true").forEach(el => {
                el.classList.remove("true");
            });
            this.classList.add("true");
            updateSeason(this.textContent.trim().toLowerCase());
        });
    });

    // Mobile select functionality
	var seasonSelect = document.getElementById("season-select");
	if (seasonSelect) {
		function updateSelectClass(selectedSeason) {
			seasonSelect.className = ""; 
			seasonSelect.classList.add(selectedSeason + "-selected"); 
		}

		seasonSelect.addEventListener("change", function () {
			let selectedSeason = this.value.toLowerCase();
			updateSeason(selectedSeason);
			updateSelectClass(selectedSeason);
		});

		updateSelectClass(savedSeason);
	}

	if(!(window.ActiveXObject) && "ActiveXObject" in window) {

		/*is explorer*/
		function msieversion() {
			let ua = window.navigator.userAgent;
			let msie = ua.indexOf("MSIE ");
			if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
			{
				const image_fit = document.getElementsByClassName('image-fit__wrapper');
				for(let i = 0; i < image_fit.length; i++ ){
					const this_image = image_fit[i].getElementsByTagName('img')[0];
					const image_data = this_image.dataset.srcset;
					const image_src = this_image.getAttribute('src');
					image_fit[i].classList.add('ie-bg');
					if(image_data){
						image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
					}else{
						image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
					}

				}
			}
			else
			{
				console.log('other browser');
			}
			return false;
		}
		msieversion();

	} else {
		/*****************************************************
		 OBSERVER TO ADD PARALLAX EFFECT
		 *****************************************************/
		let scrollParallax = []
		let scrolled = 0

		/* screen height */
		let v_height = window.innerHeight
			|| document.documentElement.clientHeight
			|| document.body.clientHeight;

		function doParallax(elm) {

			let boundes = elm.dataset.parallax.split(",") /* get it from html */
			/*get distance in positive value*/
			let distance = Math.abs(boundes[0] - boundes[1])
			if (boundes[0] > boundes[1]) {
				/*get distance in negative value (to do the scroll inverse)*/
				distance = distance * -1
			}
			/*Equivalent distance using screen height + element height*/
			const unit_scroll = distance / (v_height + elm.offsetHeight)
			let temp = 0

			let topElement = 0;
			let element = elm;

			let id_elem = elm.dataset.parallaxid

			do {
				topElement += element.offsetTop || 0;
				element = element.offsetParent;
			} while (element)

			let parallaxFunction = function () {
				/*Obtain the distance between top screen and document top 0*/
				scrolled = document.documentElement.scrollTop || window.pageYOffset
				/*Distance of bottom page to top of the element*/
				let relative_distance = scrolled + v_height - topElement
				/*transpoling data to move the parallax element relative to the scroll of all the screen*/
				temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
				/*console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)*/
				elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
			}

			scrollParallax[id_elem] = parallaxFunction

			window.addEventListener('scroll', scrollParallax[id_elem])

		}

		let observers_parallax = document.querySelectorAll(".js-parallax-element")

		if (observers_parallax) {
			let options_parallax = {
				root: null, /* relative to document viewport */
				rootMargin: '0px', /* margin around root. Values are similar to css property. Unitless values not allowed */
				threshold: 0 /* visible amount of item shown in relation to root */
			}

			function handler_parallax(entries, observer) {
				let entry;
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						doParallax(entry.target)
					} else {
						let id_elem = entry.target.dataset.parallaxid
						window.removeEventListener('scroll', scrollParallax[id_elem])
					}
				})
			}

			let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
			let counter = 1
			observers_parallax.forEach(function (element) {
				observable_parallax.observe(element)
				element.dataset.parallaxid = counter
				counter++
			})
		}
		/********************************************************************************
		 END OF OBSERVER TO ADD PARALLAX EFFECT
		 ***********************************************************************************/
	}

	/* Text and Form Animations */
	let formModule = document.querySelectorAll('.form-module-wrapper form');
	let textModule = document.querySelectorAll('.text-modules-wrapper .text-modules');
	if(formModule){
		formModule.forEach(function(form_module) {
			form_module.classList.add('animate-fade', 'top');
		});
	}
	if(textModule){
		textModule.forEach(function(text_module) {
			text_module.classList.add('animate-fade', 'top');
		});
	}

	/* Remove empty <p> tags created by tinymce */
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//// Forms animation for labels   ----------------------------------------------------------------
	if (document.getElementById('email-signup_email_address')) {
		document.getElementById('email-signup_email_address').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_FNAME')) {
		document.getElementById('email-signup_FNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_LNAME')) {
		document.getElementById('email-signup_LNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	//CMS forms label animation ----------------------------------------------------------------
	if (document.getElementsByClassName('form-module__field').length > 0) {
		const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
		MODULE_FIELDS.forEach((field) => {
			if (field.getElementsByTagName('input').length > 0) {
				if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					field.getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			}
			if (field.getElementsByTagName('select').length > 0) {
				field.getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
			if (field.getElementsByTagName('textarea').length > 0) {
				field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
		});
	}

	document.addEventListener('DOMContentLoaded', () => {

		if (savedSeason) {
			emulateGalleryFilterClick(savedSeason);
		}

		 //ADA
		document.addEventListener('keyup', function(event) {
			if (event.key === 'Tab') {
			const skipLink = document.querySelector('.skip-to-content');
	
			if (!skipLink.hasBeenFocused) {
				skipLink.focus();
				skipLink.hasBeenFocused = true;
				}
			}
		});


		// function convertBtn(classList, excludeElementSelector) {
		// 	if (classList.length > 0) {
		// 	classList.forEach((className) => {
		// 		let elements = document.querySelectorAll('.' + className);
		// 		elements.forEach((btn) => {
		// 		// Verificar si el elemento actual no coincide con el selector de exclusión
		// 		if (!btn.matches(excludeElementSelector)) {
		// 			let INNER_TEXT = btn.innerHTML;
		// 			btn.innerHTML = '<span>' + INNER_TEXT + '</span>';
		// 		}
		// 		});
		// 	});
		// 	}
		// }
	
		//convertBtn(['btn']);

		// booking inline 

		if(document.getElementById('container-booking-widget')){
            let actualDay = new Date();
            let actualDayMore = new Date();
            actualDayMore.setDate(actualDay.getDate() + 3);	
            let checkInBooking = document.getElementById('check-in');
            let checkOutBooking = document.getElementById('check-out');
            let bookingWidget = document.getElementById('booking-widget');
    
            flatpickr.localize({
                rangeSeparator: " - "
            });
            
            flatpickr("#dates_fake_booking", {
                showMonths: 2,
                minDate : actualDay,
                mode: 'range',
                dateFormat: 'm/d/Y',
                allowInput: true,
                defaultDate: {actualDay, actualDayMore},
                onChange: function(selectedDates, dateStr, instance) {
                    let dates = dateStr.split('-');
                    checkInBooking.value = dates[0].trim();
                    checkOutBooking.value = dates[1].trim();
                }
            });
        }

		// ---------------------------------------------------------------- GENERAL SITE'S FUNCTIONS ----------------------------------------------------------------


		if(document.getElementById('header').classList.contains('sitemap') || document.getElementById('gallery-flex') || document.getElementById('default') || document.getElementById('attractions')  || document.getElementById('contact-us') || document.getElementById('restricted')){
			document.getElementById('header').classList.add('scroll');
			swapLogo();

			window.addEventListener('scroll', function(){
				let st = window.pageYOffset || document.documentElement.scrollTop;
				const header = document.getElementById('header');
				const toggle = document.querySelector('.visit-content');

				if(toggle){
					if (st > lastScrollTop){
						toggle.classList.add('down');
						header.classList.add('down');
						toggle.classList.remove('up');
						header.classList.remove('up');
					} else {
						toggle.classList.add('up');
						header.classList.add('up');
						toggle.classList.remove('down');
						header.classList.remove('down');
					}	
				}
				lastScrollTop = st <= 0 ? 0 : st; 
			})

		}
		else{
			scrollW();

			window.addEventListener('scroll', function(){
				scrollW();
			})
		}

		// Main Nav Dropdown
		let primaryNav = document.getElementById('primary-nav');
		if(primaryNav){
			primaryNav.querySelectorAll('li').forEach(function(primary_nav) {
				primary_nav.addEventListener("mouseover", (event) => {
					primary_nav.classList.add('hover');
					if(primary_nav.querySelector('ul.submenu')){
						primary_nav.querySelector('ul.submenu').classList.add('open');
					}
				});
				primary_nav.addEventListener("mouseout", (event) => {
					primary_nav.classList.remove('hover');
					if(primary_nav.querySelector('ul.submenu')){
						primary_nav.querySelector('ul.submenu').classList.remove('open');
					}
				});
			});
		}

		let secondaryNav = document.getElementById('secondary-header-ul_nav');
		if(secondaryNav){
			secondaryNav.querySelectorAll('li').forEach(function(secondary_nav) {
				secondary_nav.addEventListener("mouseover", (event) => {
					secondary_nav.classList.add('hover');
					if(secondary_nav.querySelector('ul.submenu')){
						secondary_nav.querySelector('ul.submenu').classList.add('open');
					}
				});
				secondary_nav.addEventListener("mouseout", (event) => {
					secondary_nav.classList.remove('hover');
					if(secondary_nav.querySelector('ul.submenu')){
						secondary_nav.querySelector('ul.submenu').classList.remove('open');
					}
				});
			});
		}

		/* Lightbox Gallerys */
		const customLightbox = new LBX('.js-lbx-gallery', {
			customClass:'lbx-gallery',
		});


		// ---------------------------------------------------------------- INDIVIDUAL SITE'S FUNCTIONS ----------------------------------------------------------------

		// BURGUER MENU DESKTOP ----------------------------------------------------------------

		const menuBtn = document.getElementById('menu-btn');
		const navigation = document.querySelector('.navigation');
		const closeMenuBtn = document.querySelector('.js-close-menu');
		menuBtn.addEventListener('click', function(event) {
			event.preventDefault();
			navigation.classList.add('open');
		});

		closeMenuBtn.addEventListener('click', function(event) {
			event.preventDefault();
			navigation.classList.remove('open');
		});

		// BURGUER MENU MOBILE ----------------------------------------------------------------

		const burgerMenuBtn = document.querySelector("#js-burgerMenuBtn");
		const burgerMenuContainer = document.querySelector("#js-menuContainer")
		const closeMenu = document.querySelector(".js-burger-close");

		//Open Menu

		if(burgerMenuBtn){
			burgerMenuBtn.addEventListener('click', function (e) {
				e.preventDefault();
				burgerMenuContainer.classList.add("open");
				document.body.classList.add("no-scroll");
			});
		}
		
		if(closeMenu){
			closeMenu.addEventListener('click', () => {
				burgerMenuContainer.classList.remove("open");
				document.body.classList.remove("no-scroll");
			});
		}

		// SHOW SUBMENU FUNCTION: 

		const submenuToShow = (linksSelector, linkSubmenu) => {
			let navLinks = document.querySelectorAll(linksSelector); 
			let submenu_active = document.querySelectorAll(linkSubmenu); 

			navLinks.forEach(link => {
				const parent = link.parentNode;
				let submenu = parent.querySelector('.submenu');
				link.addEventListener('click', (e) => {
					link.classList.toggle('active');
					submenu.classList.toggle('active');
				});
			});
			submenu_active.forEach(sub => {
				if (sub.classList.contains('active')) {
					if (window.screen.width > 640) {
						let selectedLink = sub.parentNode.parentNode.parentNode.children[0];
						selectedLink.classList.add('selected');
					}else{
						let selectedLink = sub.parentNode.parentNode.parentNode.parentNode.children[0];
						selectedLink.classList.add('selected');
					}
				}

			})
		}

		if (window.screen.width > 640) {
			submenuToShow('#primary-nav li a', '.submenu li a');
		} else {
			submenuToShow('.mobileMenu__nav li a', '.sub-sub-menu .submenu li a');
		}

		// Seleccionar todos los elementos .privary-navigation__item
	const navItems = document.querySelectorAll('.privary-navigation__item');
	const navItemsMob = document.querySelectorAll('.mobileMenu__nav li');

	function addNoSubmenuClass() {
		navItems.forEach(item => {
			const submenu = item.querySelector('.privary-navigation__submenu');
			if (!submenu) {
				item.classList.add('no-submenu');
			}
		});
	}
	
	function addNoSubmenuMobileClass() {
		navItemsMob.forEach(item => {
			const submenu = item.querySelector('.sub-sub-menu');
			if (!submenu) {
				item.classList.add('no-submenu');
			}
		});
	}
	if(window.screen.width > 768) {
		addNoSubmenuClass();

	}else{
		addNoSubmenuMobileClass()
	}
	});

	// Image Tabs Functionality
	let fullQuadTabs = document.querySelectorAll('.image_tabs');

	if (fullQuadTabs.length > 0) {
		fullQuadTabs.forEach(fullQuadTabsQuad => {
			let tabs = document.querySelectorAll(".image_tabs--links .link");
			let contents = document.querySelectorAll(".image_tabs--content");

			// Activar el primer tab y su contenido por defecto
			if (tabs.length > 0 && contents.length > 0) {
				tabs[0].classList.add('active');
				contents[0].classList.add('show');
			}

			tabs.forEach(tab => {
				tab.addEventListener('click', function (e) {
					e.preventDefault();

					let currentTab = this.getAttribute("data-tab");

					// Remover clases activas de todas las pestañas y contenidos
					tabs.forEach(item => item.classList.remove('active'));
					contents.forEach(item => item.classList.remove('show'));

					// Agregar clase activa a la pestaña y contenido seleccionados
					document.querySelector(`.image_tabs--links .link[data-tab="${currentTab}"]`).classList.add('active');
					document.querySelector(`.image_tabs--content[data-tab="${currentTab}"]`).classList.add('show');
				});
			});
		});
	}

	if(document.querySelector('.js-scroll')){
		document.querySelectorAll('.js-scroll').forEach((btn)=>{
			btn.addEventListener('click',(e)=>{
				e.preventDefault;
				let elementTarget = btn.getAttribute('href');
				elementTarget =	elementTarget.split('#');
				animateto(elementTarget[1]);
			})
		})
	}

	let urlPageJs = document.URL;
	
	if (urlPageJs.indexOf("#") != -1) {
		tagertScroll = urlPageJs.split("#")[1];
		setTimeout(() => {
			if(tagertScroll.includes('menu')){
				goToMenu(tagertScroll)
			}else{
				animateto(tagertScroll)
			}
		}, 1000);
	}

	const customLightbox = new LBX(".open-lightbox");

	if(document.querySelector('.accordion-block')){
		document.querySelectorAll('.accordion-block').forEach((accordion)=>{

			let allAccordionItems = accordion.querySelectorAll('.js-accordion-title');

			allAccordionItems.forEach((item)=>{
				item.addEventListener('click', function(){
					let currentParent = this.parentElement;
					let currentCopyHeight = currentParent.getElementsByClassName('wrap')[0].clientHeight;
					let currentCopy = currentParent.getElementsByClassName('js-accordion-copy')[0];
					if(currentParent.classList.contains('open')){
						currentParent.classList.remove('open');
						currentCopy.style.height = '0';
					} else {
						currentParent.classList.add('open');
						currentCopy.style.height = currentCopyHeight + 'px';
					}
				})
			})
		})
	}

})();


function goToMenu(tagert){
	let menuSlider = document.querySelectorAll('.menus-block__tab.swiper-slide');
	let parentSlider = document.querySelector('.menus-block__tabs').swiper;
	if(menuSlider){
		let menuId = tagert.split("-")[1];
		menuSlider.forEach((eachSlider, index)=> {
			if(eachSlider.dataset.menu == menuId){
				parentSlider.slideTo(index);
				setTimeout(() => {
					eachSlider.click();
					animateto('Menus');
				}, 500);
			}
		});
	}
}

function animateto(target){
	if( !document.getElementById(target) )
		return false;

	var gotoTarget = offset(document.getElementById(target)).top - 110;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300;
	var start = new Date().getTime()

	/* Time Interval */
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var y = easeInOutQuart(time, from, to - from, duration)
		} else {

			var y = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, y)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}
/* Ease Movement */
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
/* ScrollW */

function swapLogo() {
    let logoImg = document.querySelector('.header__logo img');
    if (logoImg) {
        let currentSrc = logoImg.getAttribute('src');
        let scrollSrc = logoImg.getAttribute('data-src');

        if (scrollSrc) {
            logoImg.setAttribute('src', scrollSrc);
            logoImg.setAttribute('data-src', currentSrc);
        }
    }

}


function scrollW(){
    let st = window.pageYOffset || document.documentElement.scrollTop;
    const header = document.getElementById('header');
	const toggle = document.querySelector('.visit-content');

    const topContent = document.getElementById('top-content');
    const menuDesktop = document.getElementById('menu-desktop');
    const containerBookingWidget = document.getElementById('container-booking-widget');
    let logoImg = document.querySelector('.header__logo img');

	if(toggle){
		if (st > lastScrollTop){
			toggle.classList.add('down');
			header.classList.add('down');
			toggle.classList.remove('up');
			header.classList.remove('up');
		} else {
			toggle.classList.add('up');
			header.classList.add('up');
			toggle.classList.remove('down');
			header.classList.remove('down');
		}	
	}
	

    if(st > 80){
        if(!header.classList.contains('scroll')){
            header.classList.add('scroll');
            topContent.classList.add('scroll');
            menuDesktop.classList.add('scroll');
            containerBookingWidget.classList.add('scroll');

            if (logoImg) {
                let scrollSrc = logoImg.getAttribute('data-src');
                if (scrollSrc) {
                    logoImg.setAttribute('data-src', logoImg.getAttribute('src'));
                    logoImg.setAttribute('src', scrollSrc);
                }
            }
        }
    } else {
        if(header.classList.contains('scroll')){
            header.classList.remove('scroll');
            topContent.classList.remove('scroll');
            menuDesktop.classList.remove('scroll');
            containerBookingWidget.classList.remove('scroll');

            if (logoImg) {
                let originalSrc = logoImg.getAttribute('data-src');
                if (originalSrc) {
                    logoImg.setAttribute('data-src', logoImg.getAttribute('src'));
                    logoImg.setAttribute('src', originalSrc);
                }
            }
        }
    }

    lastScrollTop = st <= 0 ? 0 : st; 
}

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/
function updateMenuTabIndex() {
	const menu = document.querySelector('#menu-desktop');
	const isMenuVisible = menu && menu.classList.contains('open');
	const elements = document.querySelectorAll('#menu-desktop .privary-navigation__item a, #menu-desktop .secondary-navigation__item a, #menu-desktop .tertiary-navigation__item a, .privary-navigation__item  a');

	elements.forEach(element => {
		element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
	});
}
document.addEventListener('DOMContentLoaded', () => {
	updateMenuTabIndex();

	document.addEventListener('focusin', updateMenuTabIndex);
	const menu = document.querySelector('#menu-desktop');
	if (menu) {
		menu.addEventListener('transitionend', updateMenuTabIndex);
	}
});

/** ADA - Add aria-label to Footer Navigation **/
document.addEventListener("DOMContentLoaded", function () {
	const secondaryNavFooter = document.querySelector(".footer #secondary-footer");
	if (secondaryNavFooter) {
		secondaryNavFooter.setAttribute("aria-label", "Secondary Footer Navigation");
	}
});

function clearErrors(formId) {
	document.querySelector('input[type="text"],input[type="password"],textarea,select').classList.remove("error");
	document.querySelectorAll('#'+formId+' label').forEach( (item, index) => {
		if(item.classList.contains('errorMsg')){
			item.classList.remove('errorMsg')
		}
	} );
}

function loginMembers(e){
	e.preventDefault();
	let extras = new Object(),formId = "loginForm";
	clearErrors(formId);
	document.querySelector('.errorMsg').classList.add('hidden');

	let formData = new FormData();
	formData.append("operation", "loginMembers");
	formData.append("password", document.querySelector('#password').value);

	fetch(`${site_url}ajax/functions.php`, { method: "POST", body: formData,})
	.then((response) => response.json())
	.catch((error) => console.log(response))
	.then((response) => {

		if(response.result == 'error'){
			document.querySelector('.errorMsg').classList.remove('hidden');
		} else {
			localStorage.setItem( "username", response.name );
			location.reload();
		}
	});
}


function triggerClickFromURL() {
    const filterContainer = document.querySelector('.js-rooms__filter');
    if (!filterContainer) return;

    const params = new URLSearchParams(window.location.search);
    let value = params.get('accommodation') || params.get('tab');
    if (!value) return; 

    const cleanText = value.replace(/-/g, ' ').toLowerCase();

	/** DESKTOP */
    const buttons = filterContainer.querySelectorAll('[data-tag]');
    if (buttons.length > 0) {
        buttons.forEach(btn => {
			console.log(btn.getAttribute('data-tag').toLowerCase())
			console.log(cleanText)
            if (btn.getAttribute('data-tag').toLowerCase() === cleanText) {
                btn.click();
            }
        });
    }
	/**MOBILE */
    const select = filterContainer.querySelector('#select_room');
    if (select) {
        for (let i = 0; i < select.options.length; i++) {
            if (select.options[i].value.toLowerCase() === cleanText) {
                select.selectedIndex = i;
                select.dispatchEvent(new Event('change'));
                break;
            }
        }
    }
}

window.addEventListener('load', triggerClickFromURL);
